// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__+Hjjn","text":"style_text__AVuTg","button":"style_button__t6fxG"};